import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";


export default function CustomDropdownMenu ({margin,width,size,list,label,onSelection,value}) {



  return (
    <FormControl sx={{ m:margin?? 1, width:width??120}} size="small">
      <InputLabel id="demo-simple-select-label">{label??<span>Sort by</span>}</InputLabel>
      <Select
        variant="outlined"
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label="Sort by"
        onChange={(e) => {onSelection(e.target.value);}}
      >
        {list?.map((item,i)=>{
             return <MenuItem value={item}>{item}</MenuItem>
        })}
        
        
      </Select>
    </FormControl>
  );
};
